{
  "HELP_CENTER": {
    "TITLE": "مركز المساعدة",
    "NEW_PAGE": {
      "DESCRIPTION": "أنشئ بوابات مركز مساعدة ذاتية الخدمة لعملائك. ساعدهم في العثور على الإجابات بسرعة، دون انتظار. بسّط الاستفسارات، وعزز كفاءة الوكلاء، وارتقِ بمستوى دعم العملاء.",
      "CREATE_PORTAL_BUTTON": "إنشاء بوابة"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "بدون عنوان"
    },
    "HEADER": {
      "FILTER": "تصفية حسب",
      "SORT": "ترتيب حسب",
      "LOCALE": "اللغة",
      "SETTINGS_BUTTON": "الإعدادات",
      "NEW_BUTTON": "مقالة جديدة",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "نُشرت",
        "DRAFT": "Draft",
        "ARCHIVED": "أرشفة"
      },
      "TITLES": {
        "ALL_ARTICLES": "جميع المقالات",
        "MINE": "مقالاتي",
        "DRAFT": "مقالات مسودة",
        "ARCHIVED": "المقالات المؤرشفة"
      },
      "LOCALE_SELECT": {
        "TITLE": "حدد اللغة",
        "PLACEHOLDER": "حدد اللغة",
        "NO_RESULT": "لا توجد لغات",
        "SEARCH_PLACEHOLDER": "البحث عن اللغة"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "جميع المقالات",
      "PUBLISH_BUTTON": "نشر",
      "MOVE_TO_ARCHIVE_BUTTON": "نقل إلى الأرشيف",
      "PREVIEW": "معاينة",
      "ADD_TRANSLATION": "إضافة ترجمة",
      "OPEN_SIDEBAR": "فتح الشريط الجانبي",
      "CLOSE_SIDEBAR": "إغلاق الشريط الجانبي",
      "SAVING": "جاري الحفظ...",
      "SAVED": "تم الحفظ"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "رفع صورة",
        "UPLOADING": "جاري الرفع...",
        "SUCCESS": "تم رفع الصورة بنجاح",
        "ERROR": "حدث خطأ أثناء رفع الصورة",
        "UN_AUTHORIZED_ERROR": "غير مصرح لك برفع الصور",
        "ERROR_FILE_SIZE": "حجم الصورة يجب أن يكون أقل من {size}MB",
        "ERROR_FILE_FORMAT": "تنسيق الصورة يجب أن يكون jpg أو jpeg أو png",
        "ERROR_FILE_DIMENSIONS": "ينبغي أن تكون أبعاد الصورة أقل من 2000 × 2000"
      },
      "ANCHOR": {
        "BUTTON": "إدراج رابط داخلي",
        "TITLE": "إدراج رابط داخلي",
        "SUBMIT": "إدراج",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "إعدادات المقالة",
      "FORM": {
        "CATEGORY": {
          "LABEL": "الفئة",
          "TITLE": "اختر الفئة",
          "PLACEHOLDER": "اختر الفئة",
          "NO_RESULT": "لم يتم العثور على فئة",
          "SEARCH_PLACEHOLDER": "البحث عن فئة"
        },
        "AUTHOR": {
          "LABEL": "المؤلف",
          "TITLE": "اختر المؤلف",
          "PLACEHOLDER": "اختر المؤلف",
          "NO_RESULT": "لم يتم العثور على مؤلفين",
          "SEARCH_PLACEHOLDER": "البحث عن المؤلف"
        },
        "META_TITLE": {
          "LABEL": "العنوان الوصفي",
          "PLACEHOLDER": "اضافة عنوان وصفي"
        },
        "META_DESCRIPTION": {
          "LABEL": "وصف التعريف",
          "PLACEHOLDER": "أضف وصفك للحصول على أفضل نتائج SEO..."
        },
        "META_TAGS": {
          "LABEL": "علامات الوصف",
          "PLACEHOLDER": "إضافة وسوم ميتا مفصولة بفاصلة..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "أرشفة المقال",
        "DELETE": "حذف المقال"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "غير مصنف",
      "SEARCH_RESULTS": "نتائج البحث عن {query}",
      "EMPTY_TEXT": "ابحث عن مقالات لإدراجها في الردود.",
      "SEARCH_LOADER": "يبحث...",
      "INSERT_ARTICLE": "إدراج",
      "NO_RESULT": "لم يتم العثور على مقالات",
      "COPY_LINK": "نسخ رابط المقالة إلى الحافظة",
      "OPEN_LINK": "فتح المقالة في تبويب جديد",
      "PREVIEW_LINK": "معاينة المقالة"
    },
    "PORTAL": {
      "HEADER": "الصفحات",
      "DEFAULT": "افتراضي",
      "NEW_BUTTON": "بوابة جديدة",
      "ACTIVE_BADGE": "مفعل",
      "CHOOSE_LOCALE_LABEL": "اختر لغة محلية",
      "LOADING_MESSAGE": "جاري تحميل البوابات ...",
      "ARTICLES_LABEL": "المقالات",
      "NO_PORTALS_MESSAGE": "لا توجد بوابات متاحة",
      "ADD_NEW_LOCALE": "إضافة لغة جديدة",
      "POPOVER": {
        "TITLE": "الصفحات",
        "PORTAL_SETTINGS": "إعدادات البوابة",
        "SUBTITLE": "لديك بوابات متعددة ويمكن أن تحتوي على مواقع مختلفة لكل بوابة.",
        "CANCEL_BUTTON_LABEL": "إلغاء",
        "CHOOSE_LOCALE_BUTTON": "اختر لغة محلية"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "المقالات",
            "ADD": "إضافة لغة",
            "VISIT": "زيارة الموقع",
            "SETTINGS": "الإعدادات",
            "DELETE": "حذف"
          },
          "PORTAL_CONFIG": {
            "TITLE": "اعدادات البوابة",
            "ITEMS": {
              "NAME": "الاسم",
              "DOMAIN": "نطاق مخصص",
              "SLUG": "Slug",
              "TITLE": "عنوان البوابة",
              "THEME": "لون القالب",
              "SUB_TEXT": "النص الفرعي للبوابة"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "اللغات المتاحة",
            "TABLE": {
              "NAME": "اسم اللغة",
              "CODE": "رمز اللغة",
              "ARTICLE_COUNT": "عدد المقالات",
              "CATEGORIES": "عدد الفئات",
              "SWAP": "تبديل",
              "DELETE": "حذف",
              "DEFAULT_LOCALE": "افتراضي"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "حذف البوابة",
          "MESSAGE": "هل أنت متأكد أنك تريد حذف هذه البوابة",
          "YES": "نعم، احذف البوابة",
          "NO": "لا، احتفظ بالبوابة",
          "API": {
            "DELETE_SUCCESS": "تم حذف البوابة بنجاح",
            "DELETE_ERROR": "حدث خطأ أثناء حذف البوابة"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "تعديل البوابة",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "المعلومات الأساسية"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "تخصيص البوابة"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "الفئات"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "اللغات"
          }
        },
        "CATEGORIES": {
          "TITLE": "الفئات في",
          "NEW_CATEGORY": "فئة جديدة",
          "TABLE": {
            "NAME": "الاسم",
            "DESCRIPTION": "الوصف",
            "LOCALE": "اللغة",
            "ARTICLE_COUNT": "عدد المقالات",
            "ACTION_BUTTON": {
              "EDIT": "تعديل الفئة",
              "DELETE": "حذف الفئة"
            },
            "EMPTY_TEXT": "لم يتم العثور على الفئات"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "تحديث الإعدادات الأساسية"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "معلومات مركز المساعدة",
            "BODY": "معلومات أساسية عن البوابة"
          },
          "CUSTOMIZATION": {
            "TITLE": "تخصيص مركز المساعدة",
            "BODY": "تخصيص البوابة"
          },
          "FINISH": {
            "TITLE": "تم! 🎉",
            "BODY": "أنت جاهز!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "العودة",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "إنشاء بوابة",
            "TITLE": "معلومات مركز المساعدة",
            "CREATE_BASIC_SETTING_BUTTON": "إنشاء إعدادات البوابة الأساسية"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "تخصيص البوابة",
            "TITLE": "تخصيص مركز المساعدة",
            "UPDATE_PORTAL_BUTTON": "تحديث إعدادات البوابة"
          },
          "FINISH_PAGE": {
            "TITLE": "تم!🎉 أنت جاهز!",
            "MESSAGE": "يمكنك الآن رؤية هذه البوابة في صفحة جميع البوابات.",
            "FINISH": "الذهاب إلى صفحة جميع البوابات"
          }
        },
        "LOGO": {
          "LABEL": "الشعار",
          "UPLOAD_BUTTON": "رفع الشعار",
          "HELP_TEXT": "سيتم عرض هذا الشعار على رأس البوابة.",
          "IMAGE_UPLOAD_SUCCESS": "تم رفع الشعار بنجاح",
          "IMAGE_UPLOAD_ERROR": "تم حذف الشعار بنجاح",
          "IMAGE_DELETE_ERROR": "حدث خطأ أثناء حذف الشعار"
        },
        "NAME": {
          "LABEL": "الاسم",
          "PLACEHOLDER": "اسم البوابة",
          "HELP_TEXT": "الاسم سيتم مشاهدتة من جميع زوار الصفحة.",
          "ERROR": "الاسم مطلوب"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug البوابة المستخدم في الروابط",
          "ERROR": "Slug مطلوب"
        },
        "DOMAIN": {
          "LABEL": "نطاق مخصص",
          "PLACEHOLDER": "نطاق البوابة المخصص",
          "HELP_TEXT": "أضف هذا فقط إذا كنت تريد استخدام نطاق مخصص لبوابتك. مثال: {exampleURL}",
          "ERROR": "أدخل عنوان URL صالحًا للنطاق"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "رابط الصفحة الرئيسية",
          "PLACEHOLDER": "رابط الصفحة الرئيسية للبوابة",
          "HELP_TEXT": "الرابط المستخدم للعودة من البوابة إلى الصفحة الرئيسية. مثال: {exampleURL}",
          "ERROR": "أدخل عنوان URL صالحًا للصفحة الرئيسية"
        },
        "THEME_COLOR": {
          "LABEL": "لون قالب البوابة",
          "HELP_TEXT": "هذا اللون سيظهر كلون للبوابة."
        },
        "PAGE_TITLE": {
          "LABEL": "عنوان الصفحة",
          "PLACEHOLDER": "عنوان البوابة",
          "HELP_TEXT": "سيتم استخدام عنوان الصفحة في البوابة التي تواجه الجمهور.",
          "ERROR": "العنوان مطلوب"
        },
        "HEADER_TEXT": {
          "LABEL": "نص رأس الصفحة",
          "PLACEHOLDER": "نص رأس البوابة",
          "HELP_TEXT": "سيتم استخدام نص رأس البوابة في البوابة التي تواجه الجمهور.",
          "ERROR": "نص رأس البوابة مطلوب"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "تم إنشاء البوابة بنجاح.",
          "ERROR_MESSAGE_FOR_BASIC": "تعذر إنشاء البوابة. حاول مرة أخرى.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "تم تحديث البوابة بنجاح.",
          "ERROR_MESSAGE_FOR_UPDATE": "تعذر تحديث البوابة. حاول مرة أخرى."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "إضافة لغة جديدة",
        "SUB_TITLE": "هذا يضيف لغة جديدة إلى قائمة الترجمة المتاحة لديك.",
        "PORTAL": "البوابة",
        "LOCALE": {
          "LABEL": "اللغة",
          "PLACEHOLDER": "اختر لغة محلية",
          "ERROR": "اللغة مطلوبة"
        },
        "BUTTONS": {
          "CREATE": "إنشاء لغة",
          "CANCEL": "إلغاء"
        },
        "API": {
          "SUCCESS_MESSAGE": "تمت إضافة اللغة بنجاح",
          "ERROR_MESSAGE": "غير قادر على إضافة اللغة . حاول مرة أخرى."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "تم تحديث اللغة الغة الإفتراضية بنجاح",
          "ERROR_MESSAGE": "غير قادر على تحديث اللغة الافتراضية. حاول مرة أخرى."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "تم إزالة اللغة من البوابة بنجاح",
          "ERROR_MESSAGE": "غير قادر على إزالة اللغة من البوابة. حاول مرة أخرى."
        }
      }
    },
    "TABLE": {
      "404": "لا توجد مقالات تطابق بحثك 🔍",
      "LOADING_MESSAGE": "جاري تحميل المقالات...",
      "NO_ARTICLES": "لا توجد مقالات متوفرة",
      "HEADERS": {
        "TITLE": "العنوان",
        "CATEGORY": "الفئة",
        "READ_COUNT": "المشاهدات",
        "STATUS": "الحالة",
        "LAST_EDITED": "آخر تعديل"
      },
      "COLUMNS": {
        "BY": "بواسطة",
        "AUTHOR_NOT_AVAILABLE": "المؤلف غير متاح"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "جاري تحميل المقالات...",
      "TITLE_PLACEHOLDER": "عنوان المقالة يذهب هنا",
      "CONTENT_PLACEHOLDER": "اكتب مقالك هنا",
      "API": {
        "ERROR": "حدث خطأ أثناء حفظ المقالة"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "حدث خطأ أثناء نشر المقالة",
        "SUCCESS": "تم نشر المقالة بنجاح"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "حدث خطأ أثناء أرشفة المقالة",
        "SUCCESS": "تم أرشفة المقالة بنجاح"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "حدث خطأ أثناء تحويل المقالة إلى مسودة",
        "SUCCESS": "تم تحويل المقالة إلى مسودة بنجاح"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "تأكيد الحذف",
          "MESSAGE": "هل أنت متأكد من حذف المقالة؟",
          "YES": "نعم، احذف",
          "NO": "لا، احتفظ به"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "تم حذف المقالة بنجاح",
        "ERROR_MESSAGE": "حدث خطأ أثناء حذف المقالة"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "الرجاء إضافة عنوان ومحتوى المقالة، عندها فقط يمكنك تحديث الإعدادات"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "البحث عن مقالات"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "إنشاء فئة",
        "SUB_TITLE": "سيتم استخدام الفئة في البوابة التي تواجه الجمهور لتصنيف المقالات.",
        "PORTAL": "البوابة",
        "LOCALE": "اللغة",
        "NAME": {
          "LABEL": "الاسم",
          "PLACEHOLDER": "اسم الفئة",
          "HELP_TEXT": "سيتم استخدام اسم الفئة وأيقونتها في البوابة التي تواجه الجمهور لتصنيف المقالات.",
          "ERROR": "الاسم مطلوب"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug الفئة المستخدم في الروابط",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug مطلوب"
        },
        "DESCRIPTION": {
          "LABEL": "الوصف",
          "PLACEHOLDER": "أعط وصفًا قصيرًا عن الفئة.",
          "ERROR": "الوصف مطلوب"
        },
        "BUTTONS": {
          "CREATE": "إنشاء فئة",
          "CANCEL": "إلغاء"
        },
        "API": {
          "SUCCESS_MESSAGE": "تم إنشاء الفئة بنجاح",
          "ERROR_MESSAGE": "تعذر إنشاء الفئة"
        }
      },
      "EDIT": {
        "TITLE": "تعديل فئة",
        "SUB_TITLE": "سيؤدي تعديل الفئة إلى تحديثها في البوابة التي تواجه الجمهور.",
        "PORTAL": "البوابة",
        "LOCALE": "اللغة",
        "NAME": {
          "LABEL": "الاسم",
          "PLACEHOLDER": "اسم الفئة",
          "HELP_TEXT": "سيتم استخدام اسم الفئة وأيقونتها في البوابة التي تواجه الجمهور لتصنيف المقالات.",
          "ERROR": "الاسم مطلوب"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug الفئة المستخدم في الروابط",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug مطلوب"
        },
        "DESCRIPTION": {
          "LABEL": "الوصف",
          "PLACEHOLDER": "أعط وصفًا قصيرًا عن الفئة.",
          "ERROR": "الوصف مطلوب"
        },
        "BUTTONS": {
          "CREATE": "تحديث الفئة",
          "CANCEL": "إلغاء"
        },
        "API": {
          "SUCCESS_MESSAGE": "تم تحديث الفئة بنجاح",
          "ERROR_MESSAGE": "تعذر تحديث الفئة"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "تم حذف الفئة بنجاح",
          "ERROR_MESSAGE": "تعذر حذف الفئة"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "البحث في المقالات",
      "PLACEHOLDER": "البحث في المقالات",
      "NO_RESULT": "لم يتم العثور على مقالات",
      "SEARCHING": "يبحث...",
      "SEARCH_BUTTON": "بحث",
      "INSERT_ARTICLE": "إدراج رابط",
      "IFRAME_ERROR": "عنوان URL فارغ أو غير صالح. تعذر عرض المحتوى.",
      "OPEN_ARTICLE_SEARCH": "إدراج مقالة من مركز المساعدة",
      "SUCCESS_ARTICLE_INSERTED": "تم إدراج المقالة بنجاح",
      "PREVIEW_LINK": "معاينة المقالة",
      "CANCEL": "أغلق",
      "BACK": "العودة",
      "BACK_RESULTS": "العودة إلى النتائج"
    },
    "UPGRADE_PAGE": {
      "TITLE": "مركز المساعدة",
      "DESCRIPTION": "أنشئ بوابات ذاتية الخدمة سهلة الاستخدام. ساعد مستخدميك على الوصول إلى المقالات والحصول على الدعم على مدار الساعة طوال أيام الأسبوع. قم بترقية اشتراكك لتفعيل هذه الميزة.",
      "SELF_HOSTED_DESCRIPTION": "أنشئ بوابات ذاتية الخدمة سهلة الاستخدام. ساعد مستخدميك على الوصول إلى المقالات والحصول على الدعم على مدار الساعة طوال أيام الأسبوع. يرجى التواصل مع مسؤول النظام لتفعيل هذه الميزة.",
      "BUTTON": {
        "LEARN_MORE": "اعرف المزيد",
        "UPGRADE": "ترقية"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "بوابات متعددة",
          "DESCRIPTION": "أنشئ عدة بوابات لمركز المساعدة لمنتجات مختلفة باستخدام نفس الحساب."
        },
        "LOCALES": {
          "TITLE": "دعم كامل للغات",
          "DESCRIPTION": "قم بترجمة البوابة إلى لغتك. نحن ندعم جميع اللغات ونتيح الترجمة لكل مقالة."
        },
        "SEO": {
          "TITLE": "تصميم متوافق مع SEO",
          "DESCRIPTION": "خصص الوسوم الوصفية (meta tags) لتحسين ظهورك في محركات البحث بفضل صفحاتنا المتوافقة مع SEO."
        },
        "API": {
          "TITLE": "دعم كامل لواجهة API",
          "DESCRIPTION": "استخدم البوابة كنظام CMS بدون واجهة أمامية مع أطر عمل خارجية باستخدام واجهات API الخاصة بنا."
        }
      }
    },
    "LOADING": "جار التحميل...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} مشاهدة | {count} مشاهدات",
          "DROPDOWN_MENU": {
            "PUBLISH": "نشر",
            "DRAFT": "Draft",
            "ARCHIVE": "أرشفة",
            "DELETE": "حذف"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "نُشرت",
            "ARCHIVED": "أرشفة"
          },
          "CATEGORY": {
            "UNCATEGORISED": "غير مصنف"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "جميع المقالات",
          "MINE": "مقالاتي",
          "DRAFT": "Draft",
          "PUBLISHED": "نُشرت",
          "ARCHIVED": "أرشفة"
        },
        "CATEGORY": {
          "ALL": "جميع الفئات"
        },
        "LOCALE": {
          "ALL": "جميع اللغات"
        },
        "NEW_ARTICLE": "مقالة جديدة"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "اكتب مقالة",
          "SUBTITLE": "اكتب مقالة غنية بالمحتوى، لنبدأ!",
          "BUTTON_LABEL": "مقالة جديدة"
        },
        "MINE": {
          "TITLE": "لم تكتب أي مقالات هنا بعد",
          "SUBTITLE": "تظهر هنا جميع المقالات التي كتبتها للوصول السريع إليها."
        },
        "DRAFT": {
          "TITLE": "لا توجد مقالات في المسودات",
          "SUBTITLE": "ستظهر مقالات المسودة هنا"
        },
        "PUBLISHED": {
          "TITLE": "لا توجد مقالات منشورة",
          "SUBTITLE": "ستظهر المقالات المنشورة هنا"
        },
        "ARCHIVED": {
          "TITLE": "لا توجد مقالات في الأرشيف",
          "SUBTITLE": "لا تظهر المقالات المؤرشفة في البوابة، ويمكنك استخدامها لتمييز الصفحات القديمة أو التي عفا عليها الزمن"
        },
        "CATEGORY": {
          "TITLE": "لا توجد مقالات في هذه الفئة",
          "SUBTITLE": "ستظهر المقالات في هذه الفئة هنا"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "فئة جديدة",
        "EDIT_CATEGORY": "تعديل الفئة",
        "CATEGORIES_COUNT": "{n} فئة | {n} فئات",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "الفئات ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} مقالات) | {categoryName} ({categoryCount} مقالة)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "لم يتم العثور على الفئات",
        "SUBTITLE": "ستظهر الفئات هنا. يمكنك إضافة فئة بالنقر على زر 'فئة جديدة'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} مقالة | {count} مقالات",
        "EXPAND": "إظهار الفئات الفرعية",
        "COLLAPSE": "إخفاء الفئات الفرعية",
        "MENU": {
          "NEW_ARTICLE": "مقالة جديدة",
          "ADD_SUBCATEGORY": "إضافة فئة فرعية",
          "EDIT": "تعديل",
          "DELETE": "حذف"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "تم إنشاء الفئة بنجاح",
            "ERROR_MESSAGE": "تعذر إنشاء الفئة"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "تم تحديث الفئة بنجاح",
            "ERROR_MESSAGE": "تعذر تحديث الفئة"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "تم حذف الفئة بنجاح",
            "ERROR_MESSAGE": "تعذر حذف الفئة"
          },
          "CONFIRM": {
            "TITLE": "حذف الفئة",
            "DESCRIPTION": "هل أنت متأكد أنك تريد حذف هذه الفئة؟ ستصبح مقالاتها غير مصنفة.",
            "DESCRIPTION_WITH_CHILDREN": "هل أنت متأكد أنك تريد حذف هذه الفئة؟ ستصبح مقالاتها غير مصنفة وستُنقل فئتها الفرعية ({count}) إلى المستوى الأعلى. | هل أنت متأكد أنك تريد حذف هذه الفئة؟ ستصبح مقالاتها غير مصنفة وستُنقل فئاتها الفرعية ({count}) إلى المستوى الأعلى.",
            "CONFIRM": "حذف"
          }
        },
        "HEADER": {
          "CREATE": "إنشاء فئة",
          "EDIT": "تعديل الفئة",
          "DESCRIPTION": "سيؤدي تعديل الفئة إلى تحديثها في البوابة التي تواجه الجمهور.",
          "PORTAL": "البوابة",
          "LOCALE": "اللغة"
        },
        "FORM": {
          "NAME": {
            "LABEL": "الاسم",
            "PLACEHOLDER": "اسم الفئة",
            "ERROR": "الاسم مطلوب"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug الفئة المستخدم في الروابط",
            "ERROR": "Slug مطلوب",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "الوصف",
            "PLACEHOLDER": "أعط وصفًا قصيرًا عن الفئة.",
            "ERROR": "الوصف مطلوب"
          },
          "PARENT_CATEGORY": {
            "LABEL": "الفئة الرئيسية",
            "PLACEHOLDER": "اختر فئة رئيسية",
            "NONE": "بدون (المستوى الأعلى)"
          }
        },
        "BUTTONS": {
          "CREATE": "إنشاء",
          "EDIT": "تحديث",
          "CANCEL": "إلغاء"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "لا توجد لغات متاحة | {n} لغة | {n} لغات",
      "NEW_LOCALE_BUTTON_TEXT": "لغة جديدة",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} مقالة | {count} مقالات",
        "CATEGORIES_COUNT": "{count} فئة | {count} فئات",
        "DEFAULT": "افتراضي",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "تعيين كافتراضي",
          "DELETE": "حذف"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "إضافة لغة جديدة",
        "DESCRIPTION": "حدد اللغة التي ستُكتب بها هذه المقالة. سيتم إضافتها إلى قائمة الترجمات لديك، ويمكنك إضافة المزيد لاحقًا.",
        "COMBOBOX": {
          "PLACEHOLDER": "حدد اللغة..."
        },
        "API": {
          "SUCCESS_MESSAGE": "تمت إضافة اللغة بنجاح",
          "ERROR_MESSAGE": "غير قادر على إضافة اللغة . حاول مرة أخرى."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "جاري الحفظ...",
          "SAVED": "تم الحفظ"
        },
        "PREVIEW": "معاينة",
        "PUBLISH": "نشر",
        "DRAFT": "Draft",
        "ARCHIVE": "أرشفة",
        "BACK_TO_ARTICLES": "العودة إلى المقالات"
      },
      "DRAFT": {
        "PENDING_LABEL": "تغييرات غير منشورة",
        "PROMOTE": "نشر التغييرات",
        "DISCARD": "تجاهل التغييرات",
        "PROMOTE_SUCCESS": "تم نشر تغييرات المسودة في المقالة المباشرة",
        "PROMOTE_ERROR": "تعذّر نشر تغييرات المسودة",
        "DISCARD_SUCCESS": "تم تجاهل تغييرات المسودة",
        "DISCARD_ERROR": "تعذّر تجاهل تغييرات المسودة"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "سجل الإصدارات",
        "TITLE": "سجل الإصدارات",
        "BACK": "العودة إلى المقالة",
        "LOADING": "جارٍ تحميل الإصدارات...",
        "EMPTY": "لا توجد إصدارات بعد. ستظهر التعديلات على هذه المقالة هنا.",
        "EMPTY_CONTENT": "لا يحتوي هذا الإصدار على أي محتوى.",
        "CURRENT_BADGE": "الحالي",
        "RESTORED_BADGE": "مستعاد",
        "AUTOMATED_USER": "تحديث تلقائي",
        "RESTORE": "استعادة هذا الإصدار",
        "RESTORE_DIALOG": {
          "TITLE": "استعادة هذا الإصدار؟",
          "DESCRIPTION": "ستعود المقالة إلى صياغة هذا الإصدار. لن يُفقد أي شيء — يبقى النص الحالي في السجل، وتستمر المقالة المنشورة في عرض الإصدار المباشر إلى أن تنشر التغيير.",
          "CONFIRM": "استعادة"
        },
        "RESTORE_SUCCESS": "تم استعادة الإصدار",
        "RESTORE_ERROR": "تعذّر استعادة هذا الإصدار",
        "FETCH_ERROR": "تعذّر تحميل سجل الإصدارات"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "المزيد من الخصائص",
        "TRANSLATE": "ترجمة",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "غير مصنف",
        "EDITOR_PLACEHOLDER": "اكتب شيئًا...",
        "HTML_EMBED": {
          "TITLE": "إدراج HTML مخصص",
          "DESCRIPTION": "الصق رمز HTML خامًا مثل iframe أو embed أو مقتطف widget. سيتم عرضه كما هو في المقالة المنشورة.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "إدراج"
        },
        "PRIMARY_CATEGORY": "الفئة الرئيسية"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "خصائص المقالة",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "وصف التعريف",
        "META_DESCRIPTION_PLACEHOLDER": "أضف وصف التعريف",
        "META_TITLE": "العنوان الوصفي",
        "META_TITLE_PLACEHOLDER": "أضف العنوان الوصفي",
        "META_TAGS": "علامات الوصف",
        "META_TAGS_PLACEHOLDER": "أضف وسوم الوصف",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "نسخ اللغة",
        "LANGUAGE_MUTATIONS_EMPTY": "لا توجد مقالات مرتبطة بعد",
        "ADD_MUTATION": "إضافة",
        "REMOVE_MUTATION": "إزالة"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "ربط نسخ اللغة",
        "SEARCH_PLACEHOLDER": "البحث عن المقالات بالعنوان",
        "EMPTY": "لا توجد مقالات مطابقة",
        "CANCEL": "إلغاء",
        "ADD_SELECTED": "إضافة المحدد",
        "SUCCESS": "تم تحديث النسخ",
        "ERROR": "فشل تحديث النسخ"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "ترجمة المقالة",
        "DESCRIPTION": "اختر اللغات التي تريد ترجمة هذه المقالة إليها. اللغات المترجمة مسبقًا سيُعاد ترجمتها إلى مسودة للمراجعة.",
        "EMPTY": "لا توجد لغات أخرى متاحة",
        "CONNECTED_BADGE": "مترجمة",
        "CANCEL": "إلغاء",
        "TRANSLATE": "ترجمة",
        "SUCCESS": "ستبدأ الترجمة قريبًا. ستظهر المقالات المترجمة كنسخ لغوية قريبًا.",
        "ERROR": "فشل بدء الترجمة"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "حدث خطأ أثناء حفظ المقالة"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "بوابة جديدة",
      "PORTALS": "الصفحات",
      "CREATE_PORTAL": "إنشاء وإدارة بوابات متعددة",
      "ARTICLES": "المقالات",
      "DOMAIN": "النطاق",
      "PORTAL_NAME": "اسم البوابة"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "إنشاء بوابة جديدة",
      "DESCRIPTION": "امنح بوابتك اسمًا وأنشئ Slug سهل الاستخدام للرابط. يمكنك تعديل كليهما لاحقًا في الإعدادات.",
      "CONFIRM_BUTTON_LABEL": "إنشاء",
      "NAME": {
        "LABEL": "الاسم",
        "PLACEHOLDER": "دليل المستخدم",
        "MESSAGE": "اختر اسمًا لبوابتك.",
        "ERROR": "الاسم مطلوب"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug مطلوب",
        "FORMAT_ERROR": "استخدم الأحرف والأرقام والشرطات فقط، على سبيل المثال: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "الشعار",
          "IMAGE_UPLOAD_ERROR": "تعذر رفع الصورة! حاول مرة أخرى",
          "IMAGE_UPLOAD_SUCCESS": "تمت إضافة الصورة بنجاح. الرجاء الضغط على حفظ التغييرات لحفظ الشعار",
          "IMAGE_DELETE_SUCCESS": "تم حذف الشعار بنجاح",
          "IMAGE_DELETE_ERROR": "تعذر حذف الشعار",
          "IMAGE_UPLOAD_SIZE_ERROR": "حجم الصورة يجب أن يكون أقل من {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "الاسم",
          "PLACEHOLDER": "اسم البوابة",
          "ERROR": "الاسم مطلوب"
        },
        "HEADER_TEXT": {
          "LABEL": "نص رأس الصفحة",
          "PLACEHOLDER": "نص رأس البوابة"
        },
        "PAGE_TITLE": {
          "LABEL": "عنوان الصفحة",
          "PLACEHOLDER": "عنوان البوابة"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "رابط الصفحة الرئيسية",
          "PLACEHOLDER": "رابط الصفحة الرئيسية للبوابة",
          "ERROR": "عنوان URL غير صالح. يجب أن يبدأ رابط الصفحة الرئيسية بـ 'http://' أو 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug البوابة"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "أداة الدردشة المباشرة",
          "PLACEHOLDER": "اختر أداة الدردشة المباشرة",
          "HELP_TEXT": "اختر أداة دردشة مباشرة ستظهر في مركز المساعدة الخاص بك"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "متاح للجميع",
          "HELP_TEXT": "اجعل البوابة متاحة للجميع عبر الرابط.",
          "OPTIONS": {
            "PUBLIC": "نعم",
            "PRIVATE": "لا"
          }
        },
        "LINK_TARGET": {
          "LABEL": "وجهة الرابط",
          "HELP_TEXT": "اختر ما إذا كانت الروابط داخل المقالات تُفتح في النافذة الحالية أو في نافذة جديدة.",
          "OPTIONS": {
            "CURRENT_WINDOW": "النافذة الحالية",
            "NEW_WINDOW": "نافذة جديدة"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "حجم الصورة الافتراضي",
          "HELP_TEXT": "الحجم المطبق على كل صورة تُدرجها في مقالة. اختر Original لإدراج الصور بحجمها الخاص واختيار حجم لكل صورة بدلاً من ذلك."
        },
        "BRAND_COLOR": {
          "LABEL": "لون العلامة التجارية"
        },
        "CUSTOM_HTML": {
          "LABEL": "HTML مخصص",
          "PLACEHOLDER": "<!-- الصق مقتطف التحليلات أو التتبع الخاص بك هنا -->",
          "HELP_TEXT": "يتم إدراجه في بداية وسم <body> في كل صفحة من صفحات مركز المساعدة. استخدمه لـ Google Analytics أو Google Tag Manager أو أي مقتطف تتبع آخر. يتم عرض الكود تمامًا كما تم إدخاله ولا يتم التحقق منه."
        },
        "SAVE_CHANGES": "حفظ التغييرات"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "نطاق مخصص",
          "LABEL": "نطاق مخصص:",
          "DESCRIPTION": "يمكنك استضافة بوابتك على نطاق مخصص. على سبيل المثال، إذا كان موقعك هو yourdomain.com وتريد أن تكون بوابتك متاحة على docs.yourdomain.com، فما عليك سوى إدخال ذلك في هذا الحقل.",
          "PLACEHOLDER": "نطاق البوابة المخصص",
          "EDIT_BUTTON": "تعديل النطاق المخصص",
          "ADD_BUTTON": "إضافة نطاق مخصص",
          "DIALOG": {
            "ADD_HEADER": "إضافة نطاق مخصص",
            "EDIT_HEADER": "تعديل النطاق المخصص",
            "ADD_CONFIRM_BUTTON_LABEL": "إضافة النطاق",
            "EDIT_CONFIRM_BUTTON_LABEL": "تحديث النطاق",
            "LABEL": "نطاق مخصص",
            "PLACEHOLDER": "نطاق البوابة المخصص",
            "ERROR": "النطاق المخصص مطلوب"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "إعدادات DNS",
            "DESCRIPTION": "سجّل الدخول إلى الحساب لديك مع مزود DNS، وأضف سجل CNAME أدناه للنطاق الفرعي الخاص بك.",
            "HELP_TEXT": "بمجرد الانتهاء من ذلك، يمكنك التواصل مع فريق الدعم لطلب شهادة SSL التي يتم إنشاؤها تلقائيًا.",
            "CONFIRM_BUTTON_LABEL": "فهمت!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "حذف {portalName}",
          "HEADER": "حذف البوابة",
          "DESCRIPTION": "احذف هذه البوابة نهائيًا. هذا الإجراء لا يمكن التراجع عنه",
          "DIALOG": {
            "HEADER": "هل أنت متأكد أنك تريد حذف {portalName}؟",
            "DESCRIPTION": "هذا إجراء دائم لا يمكن التراجع عنه.",
            "CONFIRM_BUTTON_LABEL": "حذف"
          }
        },
        "EDIT_CONFIGURATION": "تعديل الإعدادات"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "تم إنشاء البوابة بنجاح",
          "ERROR_MESSAGE": "تعذر إنشاء البوابة"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "تم تحديث البوابة بنجاح",
          "ERROR_MESSAGE": "تعذر تحديث البوابة"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "المرفقات",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "إضافة ملف",
      "DROP_HERE": "اسحب وأفلت الملفات هنا",
      "COPY_LINK": "نسخ الرابط",
      "LINK_COPIED": "تم نسخ الرابط إلى الحافظة",
      "COPY_FAILED": "فشل نسخ الرابط",
      "DELETE": "حذف",
      "CANCEL": "إلغاء",
      "QUEUED": "في الانتظار",
      "UPLOADING": "جاري الرفع",
      "UPLOAD_FAILED": "فشل رفع الملف",
      "FILE_TOO_LARGE": "يتجاوز حجم الملف الحد الأقصى المسموح به وهو 40 ميجابايت"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "قاموس الترجمة",
        "DESCRIPTION": "تُضاف المصطلحات المعرّفة هنا إلى موجّه ترجمة الذكاء الاصطناعي (AI) حتى تُترجم دائمًا بالطريقة نفسها. المصطلح الأساسي مكتوب بلغة {locale}."
      },
      "NEW_TERM": "مصطلح جديد",
      "EMPTY_STATE": {
        "TITLE": "لا توجد مصطلحات في القاموس بعد",
        "SUBTITLE": "أضف مصطلحًا وترجمته لكل لغة. عند ترجمة مقالة، يتم فرض استخدام هذه المصطلحات للحفاظ على اتساق مصطلحات منتجك."
      },
      "LIST": {
        "TERM": "المصطلح",
        "TRANSLATIONS": "الترجمات",
        "ACTIONS": "الإجراءات"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "إضافة مصطلح",
          "EDIT": "تعديل المصطلح",
          "DESCRIPTION": "يتم فرض استخدام المصطلح أدناه أثناء ترجمة مقالات مركز المساعدة بالذكاء الاصطناعي.",
          "PORTAL": "البوابة",
          "PRIMARY_LANGUAGE": "اللغة الأساسية"
        },
        "FORM": {
          "TERM": {
            "LABEL": "المصطلح ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "المصطلح مطلوب"
          },
          "DESCRIPTION": {
            "LABEL": "السياق / ملاحظات (اختياري)",
            "PLACEHOLDER": "متى وكيف يُستخدم هذا المصطلح، لمساعدة المترجم على تحديد المعنى المقصود بدقة."
          },
          "TRANSLATIONS": "الترجمات",
          "TRANSLATION_PLACEHOLDER": "اتركه فارغًا للسماح للذكاء الاصطناعي بالترجمة بحرية",
          "AUTO_TRANSLATE": {
            "BUTTON": "ترجمة تلقائية للكل",
            "CONFIRM": "ترجمة إلى {count} لغة باستخدام الذكاء الاصطناعي؟",
            "CONFIRM_BUTTON": "ترجمة",
            "CANCEL": "إلغاء",
            "SUCCESS": "تم إنشاء الترجمات — راجعها واحفظها",
            "ERROR": "تعذرت الترجمة التلقائية، يرجى المحاولة مرة أخرى"
          }
        },
        "BUTTONS": {
          "CREATE": "إضافة مصطلح",
          "EDIT": "حفظ",
          "CANCEL": "إلغاء"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "تمت إضافة المصطلح بنجاح",
            "ERROR_MESSAGE": "تعذرت إضافة المصطلح، يرجى المحاولة مرة أخرى"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "تم تحديث المصطلح بنجاح",
            "ERROR_MESSAGE": "تعذر تحديث المصطلح، يرجى المحاولة مرة أخرى"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "حذف المصطلح",
          "DESCRIPTION": "هل أنت متأكد أنك تريد حذف هذا المصطلح؟ لن يتم فرض استخدامه بعد الآن أثناء الترجمة.",
          "CONFIRM": "حذف"
        },
        "API": {
          "SUCCESS_MESSAGE": "تم حذف المصطلح بنجاح",
          "ERROR_MESSAGE": "تعذر حذف المصطلح، يرجى المحاولة مرة أخرى"
        }
      }
    }
  }
}
